import React from 'react';
import { formatValue } from './DataTableCard';

const KpiGridCard = ({ card }) => {
  if (!card || !card.sections) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 shadow-sm w-full mt-3">
      {card.title && (
        <div className="text-xs font-semibold text-gray-700 mb-3">{card.title}</div>
      )}
      {card.sections.map((section, si) => (
        <div key={si}>
          {si > 0 && <div className="border-t border-gray-100 my-3" />}
          <div className="flex items-center gap-2 mb-2">
            {section.icon && (
              <img src={section.icon} alt="" className="w-4 h-4 object-contain" />
            )}
            <span className="text-[11px] font-semibold text-gray-600">{section.label}</span>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {(section.metrics || []).map((metric, mi) => (
              <div key={mi}>
                <div className="text-[10px] text-gray-400">{metric.label}</div>
                <div className="text-sm font-bold">
                  {formatValue(metric.value, metric.format, metric.label)}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {card.period && (
        <div className="mt-4 text-[10px] text-gray-400 text-right font-mono">
          Period {card.period.start} &rarr; {card.period.end}
        </div>
      )}
    </div>
  );
};

export default KpiGridCard;
